import React from "react"

import { Container, StarsContainer, ColorStars, Stars } from "./styles"

const StarsRating = ({ rating, renderOnMobile, isArticleProduct, totalReviews, color }) => (
  <Container renderOnMobile={renderOnMobile}>
    <StarsContainer isArticleProduct={isArticleProduct} totalReviews={totalReviews}>
      <ColorStars rating={rating} color={color}>
        <span>★ ★ ★ ★ ★</span>
      </ColorStars>
      <Stars>
        <span>★ ★ ★ ★ ★</span>
      </Stars>
    </StarsContainer>
    {totalReviews && <p>{`(${totalReviews})`}</p>}
  </Container>
)

export default StarsRating
